import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export interface ElementsListState {
  data: Data[];
  error?: ErrorObject;
}

export interface Data {
  id: string;
  name: string;
  title?: string;
  link?: string;
  informationItems?: Data[];
}

const initialState = {
  data: []
} as ElementsListState;

export default initialState;
